import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../Navbar';
import UpdateNavbar from './UpdateNavbar';
import styles from './ShowStaff.module.css';

function ShowStaff() {
    const [staffs, setStaffs] = useState([]);
    const [subject, setSubject] = useState('none');

    useEffect(() => {
        if (subject !== 'none') {
            fetchStaffs();
        }
    }, [subject]);

    const fetchStaffs = async () => {
        try {
            const result = await axios.get(`https://school-web-server-eight.vercel.app/${subject}`);
            setStaffs(result.data);
        } catch (error) {
            console.error('Error fetching staffs:', error);
        }
    };

    const handleDelete = async (id, imageName) => {
        try {
            // Delete the staff from the backend
            await axios.delete(`https://school-web-server-eight.vercel.app/${subject}/${id}`);

            // If staff deletion is successful, delete the associated image
            if (imageName && imageName !== "none_profile.jpg") {
                await axios.delete(`https://school-web-server-eight.vercel.app/${imageName}`);
            }

            // Update the local state to remove the deleted staff
            setStaffs(staffs.filter(staff => staff._id !== id));
        } catch (error) {
            console.error('Error deleting staff:', error);
        }
    };

    return (
        <>
            <Navbar />
            <UpdateNavbar />
            <div className={styles.addStaffContainer}>
                <div className='content'>
                    <div className={styles.subjectsHeader}>
                        <div className='subjects'>
                            <label htmlFor="subject">กลุ่มสาระ</label>
                            <select
                                className="subject-selector"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                required
                            >
                                <option value="none" disabled>เลือกกลุ่มสาระ</option>
                                <option value="social">สังคมศึกษาฯ</option>
                                <option value="languages">ภาษาต่างประเทศ</option>
                                <option value="physicaledu">พลศึกษาฯ</option>
                                <option value="homeeconomic">การงานอาชีพ</option>
                                <option value="art">ศิลปะ</option>
                                <option value="science">วิทยาศาสตร์</option>
                                <option value="thai">ภาษาไทย</option>
                                <option value="math">คณิตศาสตร์</option>
                            </select>
                        </div>
                        <Link to="create" className={styles.addStaff}>เพิ่มบุคลากร</Link> {/* Relative path */}
                    </div>
                    {subject !== 'none' ? (
                        <table className={styles.tableStaff}>
                            <thead>
                                <tr>
                                    <th>รูปภาพ</th>
                                    <th>ชื่อ-สกุล</th>
                                    <th>ตำแหน่ง</th>
                                    <th>อีเมล์</th>
                                    <th>แก้ไข</th>
                                </tr>
                            </thead>
                            <tbody>
                                {staffs.map((staff) => (
                                    <tr key={staff._id}>
                                        <td>
                                            <img
                                                src={`http://localhost:3003/staffImages/${staff.image}`}
                                                alt=""
                                                style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                            />
                                        </td>
                                        <td>{staff.name}</td>
                                        <td>{staff.position}</td>
                                        <td>{staff.email}</td>
                                        <td>
                                            <Link to={`update/${subject}/${staff._id}`} className={styles.updateInfo}>อัพเดทข้อมูล</Link> {/* Relative path */}
                                            <button
                                                className={styles.deleteStaff}
                                                onClick={() => handleDelete(staff._id, staff.image)}
                                            >
                                                ลบข้อมูลทั้งหมด
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p>*** กรุณาเลือกกลุ่มสาระการเรียนรู้เพื่อดูข้อมูลบุคลากร ***</p>
                    )}
                </div>
            </div>
        </>
    );
}

export default ShowStaff;
